import React from 'react';
import DropdownOption from './DropdownOption';
import PropTypes from 'prop-types';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

class SortByDropdown extends React.Component {
    constructor(props) {
        super(props)

        this.toggle = this.toggle.bind(this);
        this.state = {
            dropdownOpen: false
        };
    }

    toggle() {
        this.setState(prevState => ({
            dropdownOpen: !prevState.dropdownOpen
        }));
    }

    render() {
        const {
            CurrentSortBy,
            onCurrentSortByChange,
            SortOptions
        } = this.props;
        const dropDownOptions = SortOptions.map(so => new DropdownOption(so.DisplayName, so.Name, so.DisplayName))
        const found = dropDownOptions.find(option => {
            return option.value === CurrentSortBy;
        });
        const selectedSort = found 
            ? found 
            : dropDownOptions[0];
        const title = <span><span className="hidden-xxs">Sort By </span>{selectedSort.displayName} <i className="fa fa-angle-down" /></span>;
        return (
            <Dropdown
                isOpen={this.state.dropdownOpen}
                toggle={this.toggle}
                id={`sort-by-dropdown`}
            >
                <DropdownToggle>
                    {title}
                </DropdownToggle>
                <DropdownMenu>
                    {dropDownOptions.map((option, i) => {
                        return (
                            <DropdownItem
                                key={i}
                                active={selectedSort === option}
                                onClick={() => onCurrentSortByChange(option.value)}
                            >
                                {option.displayName}
                            </DropdownItem>
                        );
                    })

                    }
                </DropdownMenu>
            </Dropdown>
        );
    }
};

SortByDropdown.propTypes = {
    CurrentSortBy: PropTypes.string,
    onCurrentSortByChange: PropTypes.func,
    SortOptions: PropTypes.arrayOf(PropTypes.shape({
        DisplayName: PropTypes.string,
        Name: PropTypes.string,
        Selected: PropTypes.bool
    }))
};

export default SortByDropdown;


// WEBPACK FOOTER //
// ./src/Components/search/components/SortByDropdown.jsx